import React, { useState } from 'react';
import '../styles/hero.css';
import heroImg from '../assets/hero.png';
import logoImg from '../assets/logo-new.png';
import { FaChevronDown } from 'react-icons/fa';
import config from '../config';

export default function Hero() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState('');

  const scrollToProducts = () => {
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const validateEmail = (email) => {
    if (!email) {
      setEmailError('');
      return true;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return false;
    }
    
    // Check for common typos in domain
    const typos = {
      'gmial.com': 'gmail.com',
      'gmai.com': 'gmail.com',
      'yahooo.com': 'yahoo.com',
      'yaho.com': 'yahoo.com',
      'hotmial.com': 'hotmail.com',
      'outlok.com': 'outlook.com'
    };
    
    const domain = email.split('@')[1]?.toLowerCase();
    
    if (domain && typos[domain]) {
      setEmailError(`Did you mean ${typos[domain]}?`);
      return false;
    }
    
    setEmailError('');
    return true;
  };

  const handleNotifyClick = async () => {
    if (!email.trim()) {
      setEmailError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`https://formspree.io/f/${config.formspree.notificationFormId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email })
      });
      
      if (response.ok) {
        alert('Thank you! We\'ll notify you when we launch.');
        setEmail('');
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      alert('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="home" className="hero">
      <img src={heroImg} alt="Badminton Player" className="hero-bg" />
      <div className="hero-overlay">
        <div className="hero-content">
          <img src={logoImg} alt="Badminton Shop UK" className="hero-logo" />
          <h1 className="launching-soon">Launching Soon</h1>
          <h1 className="hero-subtitle">Carefully selected badminton gears and professional stringing service for UK players</h1>
          <p className="hero-description">Remember your first time on court? We do. The confusion, the mis-hits, "which racket should I even buy?" Panic! We've been beginners, improvers, and regular club/leage/county players – and we're building the shop that works for all of those stages.</p>
          <div className="hero-email-form">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError('');
              }}
              onBlur={() => validateEmail(email)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleNotifyClick();
                }
              }}
              className={emailError ? 'error' : ''}
            />
            {emailError && <span className="error-message">{emailError}</span>}
            <button 
              className="notify-btn" 
              onClick={handleNotifyClick}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Notify Me'}
            </button>
          </div>
          <button className="scroll-down-arrow" onClick={scrollToProducts} aria-label="Scroll to products">
            <FaChevronDown />
          </button>
        </div>
      </div>
    </section>
  );
}